/*
 * @Description:
 * @Author: 山淑兰
 * @Date: 2019-12-28 00:33:49
 * @LastEditTime: 2020-05-21 10:13:24
 * @LastEditors: 山淑兰
 */
import { Get, Pick } from "@/api/utils";
import { InitMeetingInfo } from "./index.dto";

const API_HOST = "";

export const RatingsPath = {
  Init_MeetingInfo: API_HOST + "/api/Meeting/InitMeetingInfo", //会议基本信息接口
};

export default {
  /**
   * @title 会议基本信息接口
   * @date 2019-12-27
   */
  InitMeetingInfo(body: InitMeetingInfo) {
    const params = Pick(body, InitMeetingInfo);
    return Get({
      url: RatingsPath.Init_MeetingInfo,
      params,
    });
  },
};
